import { Check, X } from "lucide-react";

interface ComparisonRow {
  feature: string;
  sorvaine: boolean | string;
  competitor: boolean | string;
}

interface ComparisonTableProps {
  competitorName: string;
  rows: ComparisonRow[];
}

function CellValue({ value }: { value: boolean | string }) {
  if (typeof value === "string") {
    return <span className="text-sm text-white/70">{value}</span>;
  }
  if (value === true) {
    return <Check className="w-5 h-5 text-emerald-400/80" />;
  }
  return <X className="w-5 h-5 text-white/20" />;
}

export function ComparisonTable({ competitorName, rows }: ComparisonTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-left">
        <thead>
          <tr className="border-b border-white/[0.08]">
            <th className="py-3 pr-4 text-sm font-medium text-white/40 w-1/2">Feature</th>
            <th className="py-3 px-4 text-sm font-semibold text-white/80 text-center">Sorvaine</th>
            <th className="py-3 pl-4 text-sm font-semibold text-white/80 text-center">{competitorName}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className="border-b border-white/[0.04]">
              <td className="py-3.5 pr-4 text-sm text-white/60">{row.feature}</td>
              <td className="py-3.5 px-4 text-center flex items-center justify-center">
                <CellValue value={row.sorvaine} />
              </td>
              <td className="py-3.5 pl-4 text-center">
                <span className="inline-flex items-center justify-center">
                  <CellValue value={row.competitor} />
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
